(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["azlia-calm-rebuild"] && !Shopify.designMode) return;
  try {
    
function initAzliaReference(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 root.querySelectorAll('[data-vp-photo]').forEach(button=>button.addEventListener('click',()=>{const image=root.querySelector('.vp-main-photo img');image.src=button.dataset.vpPhoto;image.alt=button.querySelector('img').alt;root.querySelectorAll('[data-vp-photo]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));}));
 root.querySelectorAll('.vp-menu a').forEach(a=>a.addEventListener('click',()=>root.querySelector('.vp-menu').removeAttribute('open')));
 root.querySelectorAll('[data-vp-carousel]').forEach(carousel=>{const track=carousel.querySelector('.vp-track'),cards=[...track.children],dots=[...carousel.querySelectorAll('[data-vp-dot]')];let index=0;const go=n=>{index=(n+cards.length)%cards.length;const card=cards[index];track.scrollTo({left:card.offsetLeft-track.offsetLeft-(track.clientWidth-card.clientWidth)/2,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});};carousel.querySelector('[data-vp-prev]').addEventListener('click',()=>go(index-1));carousel.querySelector('[data-vp-next]').addEventListener('click',()=>go(index+1));dots.forEach((d,i)=>d.addEventListener('click',()=>go(i)));track.addEventListener('scroll',()=>{const center=track.getBoundingClientRect().left+track.clientWidth/2;index=cards.reduce((best,card,i)=>Math.abs(card.getBoundingClientRect().left+card.clientWidth/2-center)<Math.abs(cards[best].getBoundingClientRect().left+cards[best].clientWidth/2-center)?i:best,0);dots.forEach((d,i)=>d.setAttribute('aria-current',String(i===index)));},{passive:true});});
 root.querySelectorAll('[data-vp-form]').forEach(form=>form.addEventListener('submit',async event=>{event.preventDefault();const button=form.querySelector('[type=submit]'),label=button.querySelector('span'),message=form.querySelector('[role=status]'),original=label.textContent;button.disabled=true;label.textContent=root.dataset.adding;message.textContent='';try{const data=new FormData(form);const response=await fetch(root.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:data.get('id'),quantity:Number(data.get('quantity'))}]})});const added=await response.json();if(!response.ok)throw new Error(added.description||root.dataset.error);message.textContent=root.dataset.added+' · ';const cartResponse=await fetch(root.dataset.cartUrl+'.js',{headers:{Accept:'application/json'}});if(cartResponse.ok){const cart=await cartResponse.json();root.querySelectorAll('[data-vp-cart]').forEach(e=>e.textContent=cart.item_count);message.textContent+=root.dataset.total+': '+new Intl.NumberFormat(document.documentElement.lang,{style:'currency',currency:cart.currency}).format(cart.total_price/100)+' · ';}const link=document.createElement('a');link.href=root.dataset.cartUrl;link.textContent=root.dataset.viewCart;message.append(link);}catch(error){message.textContent=error.message||root.dataset.error;}finally{button.disabled=false;label.textContent=original;}}));
}
document.querySelectorAll('[data-vp-root]').forEach(initAzliaReference);
document.addEventListener('shopify:section:load',event=>{const root=event.target.querySelector('[data-vp-root]');if(root)initAzliaReference(root);});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
